module.exports = __webpack_public_path__ + "static/media/generic-em.e63743a1.jpeg";